import React, { Suspense } from 'react'
import { Spin } from 'antd'

export const SuspenceFallback = ({ children }: { children: JSX.Element }) => (
  <Suspense fallback={<Spin />}>{children}</Suspense>
)
